import axios from "axios";

class DesktopAppManagerService {
    // eski API
    getDesktopAppVersions(params) {
        return axios.get('/desktop-app-manager/admin/versions/get', { params });
    }

    getDesktopAppVersionsCount(params) {
        return axios.get('/desktop-app-manager/admin/versions/count', { params });
    }

    // 🆕 yangi API
    getFileVersions(params) {
        return axios.get("/desktop-app-manager/admin/local-pos/file-version/get", {params});
    }

    getFileVersionsCount(params) {
        return axios.get("/desktop-app-manager/admin/local-pos/file-version/get/count", {params});
    }

    addNewDesktopAppVersion(payload) {
        return axios.post("/desktop-app-manager/admin/version/add", payload);
    }

    addDesktopAppNewVersion(payload) {
        return axios.post("/desktop-app-manager/admin/local-pos/file-version/add", payload);
    }

    deleteDesktopAppVersion(id) {
        return axios.post(`/desktop-app-manager/admin/version/delete/${id}`);
    }
    deleteDesktopAppNewVersion(id) {
        return axios.post(`/desktop-app-manager/admin/local-pos/file-version/delete/${id}`);
    }

    activateDesktopAppVersion(id) {
        return axios.post(`/desktop-app-manager/admin/version/activate/${id}`);
    }
    activateDesktopAppNewVersion(id) {
        return axios.post(`/desktop-app-manager/admin/local-pos/file-version/activate/${id}`);
    }

    deactivateDesktopAppVersion(id) {
        return axios.post(`/desktop-app-manager/admin/version/deactivate/${id}`);
    }

    deactivateDesktopAppNewVersion(id) {
        return axios.post(`/desktop-app-manager/admin/local-pos/file-version/deactivate/${id}`);
    }

    
}

const desktopAppManagerService = new DesktopAppManagerService();
export default desktopAppManagerService;
